var React = require('react');


var Group = React.createClass({
  render: function() {
    return (
      <div className="ofs-FormGroup">
        {this.props.children}
      </div>
    );
  }
});

module.exports = Group;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/layout/group.jsx
 **/